module.exports = __webpack_public_path__ + "Brandon_reg.1f55925e52b9e71fd571.otf";


//////////////////
// WEBPACK FOOTER
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/assets/fonts/brandon-grotesque/Brandon_reg.otf
// module id = ../../../../../src/assets/fonts/brandon-grotesque/Brandon_reg.otf
// module chunks = main